"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceSignupResponse = exports.UserServiceSignupRequest = exports.UserServiceJoinRequest = exports.UserServiceContractOrderCheckoutResponse = exports.SetupUserServiceContractPaymentsResponse = exports.SetupUserServiceContractPaymentsRequest = exports.UserServiceContractPaymentDetails = exports.BreakUserServiceContractResponse = exports.CancelUserServiceContractRequest = exports.CancelUserServiceContractResponse = exports.BreakUserServiceContractRequest = exports.SignupUserServiceContractResponse = exports.SignupUserServiceContractRequest = exports.CreateUserServiceContractResponse = exports.CreateUserServiceContractRequest = exports.ScheduleUserServiceContractRequest = void 0;
var helpers_1 = require("../../helpers");
var interfaces_1 = require("../../interfaces");
var package_1 = require("../../package");
var user_service_contract_1 = require("./user-service-contract");
var user_service_contract_order_1 = require("./user-service-contract-order");
var user_service_contractor_1 = require("./user-service-contractor");
/**
 * Запрос на резервирование времени под контракт для услуги
 */
var ScheduleUserServiceContractRequest = /** @class */function () {
  function ScheduleUserServiceContractRequest(values) {
    if (!values) {
      return;
    }
    this.user_service_id = values.user_service_id;
    this.teacher_id = values.teacher_id;
    this.schedule = new package_1.ServiceContractTerms20230418.Schedule(values.schedule);
    this.timezone = values.timezone;
    helpers_1.ValueValidation.assertUUIDv4('user_service_id', this.user_service_id);
    helpers_1.ValueValidation.assertUUIDv4('teacher_id', this.teacher_id);
    helpers_1.ValueValidation.assertDefined('schedule.interval', this.schedule.interval);
    helpers_1.ValueValidation.assertNotEmpty('schedule.events', this.schedule.events);
    this.schedule.events.map(function (event) {
      helpers_1.ValueValidation.assertDate('schedule.events[...].begin_at', event.begin_at);
      helpers_1.ValueValidation.assertDate('schedule.events[...].end_at', event.end_at);
    });
    helpers_1.ValueValidation.assertStringMinLength('timezone', this.timezone, 1);
  }
  return ScheduleUserServiceContractRequest;
}();
exports.ScheduleUserServiceContractRequest = ScheduleUserServiceContractRequest;
/**
 * Запрос на создание контракта для услуги с заданным шаблоном повторения занятий
 */
var CreateUserServiceContractRequest = /** @class */function () {
  function CreateUserServiceContractRequest(values) {
    if (!values) {
      return;
    }
    this.user_service_id = values.user_service_id;
    this.teacher_id = values.teacher_id;
    this.account_id = values.account_id;
    this.schedule = new package_1.ServiceContractTerms20230418.Schedule(values.schedule);
    this.timezone = values.timezone;
    this.currency_id = values.currency_id;
    helpers_1.ValueValidation.assertUUIDv4('user_service_id', this.user_service_id);
    helpers_1.ValueValidation.assertUUIDv4('teacher_id', this.teacher_id);
    helpers_1.ValueValidation.assertUUIDv4('account_id', this.account_id);
    helpers_1.ValueValidation.assertDefined('schedule.interval', this.schedule.interval);
    helpers_1.ValueValidation.assertNotEmpty('schedule.events', this.schedule.events);
    this.schedule.events.map(function (event) {
      helpers_1.ValueValidation.assertDate('schedule.events[...].begin_at', event.begin_at);
      helpers_1.ValueValidation.assertDate('schedule.events[...].end_at', event.end_at);
    });
    helpers_1.ValueValidation.assertStringMinLength('timezone', this.timezone, 1);
    helpers_1.ValueValidation.assertDefined('currency_id', this.currency_id);
  }
  return CreateUserServiceContractRequest;
}();
exports.CreateUserServiceContractRequest = CreateUserServiceContractRequest;
var CreateUserServiceContractResponse = /** @class */function (_super) {
  __extends(CreateUserServiceContractResponse, _super);
  function CreateUserServiceContractResponse(values) {
    var _this = _super.call(this, values) || this;
    if (values.model) {
      _this.model = new user_service_contract_order_1.UserServiceContractOrder(values.model);
    }
    if (values.contract) {
      _this.contract = new user_service_contract_1.UserServiceContract(values.contract);
    }
    if (values.contractor) {
      _this.contractor = new user_service_contractor_1.UserServiceContractor(values.contractor);
    }
    return _this;
  }
  return CreateUserServiceContractResponse;
}(interfaces_1.CommonProcessingResponse);
exports.CreateUserServiceContractResponse = CreateUserServiceContractResponse;
/** Запрос на запись на занятия в рамках услуги преподавателя */
var SignupUserServiceContractRequest = /** @class */function () {
  function SignupUserServiceContractRequest(values) {
    if (!values) {
      return;
    }
    this.user_service_contract_id = values.user_service_contract_id;
    this.currency_id = values.currency_id;
    helpers_1.ValueValidation.assertUUIDv4('user_service_contract_id', this.user_service_contract_id);
    helpers_1.ValueValidation.assertDefined('currency_id', this.currency_id);
  }
  return SignupUserServiceContractRequest;
}();
exports.SignupUserServiceContractRequest = SignupUserServiceContractRequest;
var SignupUserServiceContractResponse = /** @class */function (_super) {
  __extends(SignupUserServiceContractResponse, _super);
  function SignupUserServiceContractResponse(values) {
    var _this = _super.call(this, values) || this;
    if (values.model) {
      _this.model = new user_service_contract_order_1.UserServiceContractOrder(values.model);
    }
    if (values.contract) {
      _this.contract = new user_service_contract_1.UserServiceContract(values.contract);
    }
    if (values.contractor) {
      _this.contractor = new user_service_contractor_1.UserServiceContractor(values.contractor);
    }
    return _this;
  }
  return SignupUserServiceContractResponse;
}(interfaces_1.CommonProcessingResponse);
exports.SignupUserServiceContractResponse = SignupUserServiceContractResponse;
/** Запрос на прекращение занятий по контракту */
var BreakUserServiceContractRequest = /** @class */function () {
  function BreakUserServiceContractRequest(values) {
    if (!values) {
      return;
    }
    this.user_service_contract_id = values.user_service_contract_id;
    this.reason = Number(values.reason);
    this.comment = String(values.comment);
    helpers_1.ValueValidation.assertUUIDv4('user_service_contract_id', this.user_service_contract_id);
  }
  return BreakUserServiceContractRequest;
}();
exports.BreakUserServiceContractRequest = BreakUserServiceContractRequest;
/** Ответ на запрос о прекращении занятий по контракту */
var CancelUserServiceContractResponse = /** @class */function (_super) {
  __extends(CancelUserServiceContractResponse, _super);
  function CancelUserServiceContractResponse() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return CancelUserServiceContractResponse;
}(interfaces_1.CommonProcessingResponse);
exports.CancelUserServiceContractResponse = CancelUserServiceContractResponse;
/** Запрос на отмену контракта для услуги */
var CancelUserServiceContractRequest = /** @class */function () {
  function CancelUserServiceContractRequest(values) {
    if (!values) {
      return;
    }
    this.user_service_contract_id = values.user_service_contract_id;
    helpers_1.ValueValidation.assertUUIDv4('user_service_contract_id', this.user_service_contract_id);
  }
  return CancelUserServiceContractRequest;
}();
exports.CancelUserServiceContractRequest = CancelUserServiceContractRequest;
/** Ответ на запрос на отмену контракта для услуги */
var BreakUserServiceContractResponse = /** @class */function (_super) {
  __extends(BreakUserServiceContractResponse, _super);
  function BreakUserServiceContractResponse() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return BreakUserServiceContractResponse;
}(interfaces_1.CommonProcessingResponse);
exports.BreakUserServiceContractResponse = BreakUserServiceContractResponse;
/** Параметры платежа по контракту */
var UserServiceContractPaymentDetails = /** @class */function () {
  function UserServiceContractPaymentDetails() {}
  return UserServiceContractPaymentDetails;
}();
exports.UserServiceContractPaymentDetails = UserServiceContractPaymentDetails;
/**
 * Запрос на настройку оплаты контракта на оказание услуги
 *
 * @deprecated
 */
var SetupUserServiceContractPaymentsRequest = /** @class */function () {
  function SetupUserServiceContractPaymentsRequest(values) {
    if (!values) {
      return;
    }
    this.user_service_contract_id = values.user_service_contract_id;
    this.payment_details = values.payment_details;
    helpers_1.ValueValidation.assertUUIDv4('user_service_contract_id', this.user_service_contract_id);
  }
  return SetupUserServiceContractPaymentsRequest;
}();
exports.SetupUserServiceContractPaymentsRequest = SetupUserServiceContractPaymentsRequest;
/**
 * Ответ на запрос на настройку оплаты контракта на оказание услуги
 *
 * @deprecated
 */
var SetupUserServiceContractPaymentsResponse = /** @class */function (_super) {
  __extends(SetupUserServiceContractPaymentsResponse, _super);
  function SetupUserServiceContractPaymentsResponse() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return SetupUserServiceContractPaymentsResponse;
}(interfaces_1.CommonProcessingResponse);
exports.SetupUserServiceContractPaymentsResponse = SetupUserServiceContractPaymentsResponse;
/** Ответ на запрос о данных для оплаты контракта на услугу */
var UserServiceContractOrderCheckoutResponse = /** @class */function (_super) {
  __extends(UserServiceContractOrderCheckoutResponse, _super);
  function UserServiceContractOrderCheckoutResponse(values) {
    var _this = _super.call(this, values) || this;
    _this.meetings = values.meetings || [];
    return _this;
  }
  return UserServiceContractOrderCheckoutResponse;
}(user_service_contract_order_1.UserServiceContractOrderDetails);
exports.UserServiceContractOrderCheckoutResponse = UserServiceContractOrderCheckoutResponse;
/**
 * Для совместимости с старым кодом, чтобы портал/панель компилировались. На бэке не используются
 *
 * @deprecated
 */
var UserServiceJoinRequest = /** @class */function () {
  function UserServiceJoinRequest(values) {}
  return UserServiceJoinRequest;
}();
exports.UserServiceJoinRequest = UserServiceJoinRequest;
/**
 * Для совместимости с старым кодом, чтобы портал/панель компилировались. На бэке не используются
 *
 * @deprecated
 */
var UserServiceSignupRequest = /** @class */function () {
  function UserServiceSignupRequest(values) {}
  return UserServiceSignupRequest;
}();
exports.UserServiceSignupRequest = UserServiceSignupRequest;
/**
 * Для совместимости с старым кодом, чтобы портал/панель компилировались. На бэке не используются
 *
 * @deprecated
 */
var UserServiceSignupResponse = /** @class */function () {
  function UserServiceSignupResponse(values) {}
  return UserServiceSignupResponse;
}();
exports.UserServiceSignupResponse = UserServiceSignupResponse;
